import { transparentize } from "polished";

export const formatDateForServer = (dateISOString) => {
  const [date, time] = dateISOString.split("T");
  return [date.split("-").reverse().join("-"), time].join("T");
}

export const formatColumns = (elements) => {
    const numColumns = Math.ceil(elements.length / (22));
  return numColumns
}

const generateRandomColor = () => {
  return "#" + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0');
};

///SOMMA LE VARIABILI DEGLI ARRAY PRENDENDO LA CORRISPONDENZA IN BASE ALLA POSIZIONE
export const sumChartGroupData = (chartVars = [], associazioni = [], key = "paragoni") => {
  if (chartVars.length === 0 || associazioni.length === 0) return [];
  
  return associazioni.map((assoc, index) => {
    const { nome } = assoc;
    const ids = assoc[key]; // può essere "paragoni" o "principali"

    const varsInGroup = chartVars.filter(v => ids.includes(v.idvar));
    const numPoints = varsInGroup[0]?.data.length || 0;
    
    const summedData = Array.from({length: numPoints}, (_, i) => {
      const time = varsInGroup[0].data[i]?.time;
      const valueSum = varsInGroup.reduce((sum, curr) => {
        const value = curr.data[i]?.value ?? 0;
        return sum + value; 
      }, 0);
      return { x: time, y: valueSum };
    });

    const colorBase = assoc.color || generateRandomColor();
    const isParagon = key === "paragoni";
    const color = isParagon ? transparentize(0.4, colorBase) : colorBase;

    return {
      label: nome || `Gruppo ${index + 1}`,
      data: summedData,
      backgroundColor: color,
      borderColor: color,
      borderWidth: 1,
    };
  });
};
